module.exports = __webpack_public_path__ + "img/start-read-icon.74f9bfec.svg";